









































































































































import Button from '../../core/components/Button.vue';
import SimpleTable from '../../core/components/SimpleTable.vue';
import SectionTitle from '../../core/components/SectionTitle.vue';
import Input from '../../core/components/Input.vue';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import {
    Combobox,
    MultipleSelect
} from '../../core/components';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import Loading from 'vue-loading-overlay';
import moment from 'moment';
import VehiclesActions from './VehiclesActions.vue';
import { BroadcastsTypes, Company } from '../../core/models';
import { OptionalCompany } from '../../core/utils';
@Component({
    components: {
        Loading,
        Button,
        SimpleTable,
        SectionTitle,
        Input,
        VehiclesActions,
        MultipleSelect
    }
})
export default class ModalVehicleBroadcasts extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
    @Prop({ default: false }) visible: boolean;
    modalTitle: string = 'Configurar Broadcasts';
    pendingRequest: boolean = false;
    send_im: boolean = false;
    siporal_broadcast: boolean = false;
    enabledGreenMile: boolean = false;
    enabledMHBroadcast: boolean = false;
    greenmileNumber: any | null = null;
    mhBroadcastNumber: any | null = null;
    preselectedCompanies: Array<Company> = [];

    @Watch('send_im')
    observableSendIm(value){
        this.resetPreselectedCompanies();
    }

    resetPreselectedCompanies(){
        if(!this.send_im){
             this.preselectedCompanies = [];
        }
    }

    
    selectCompany(company: Company | OptionalCompany){
        if(company){
            this.preselectedCompanies.push(company);
        }
    }
    removeCompany(company: Company){
       this.preselectedCompanies = this.preselectedCompanies.filter(item => item.id !== company.id);
    }

     data() {
        return {
            greenMileRules: {
                required: value => !!value || 'Debe ingresar un valor',
                counter: value => value !== null && value.length <= 45 || 'GreenMile ID debe tener máximo 45 caracteres'
            },
            mhBroadcastRules: {
                required: value => !!value || 'Debe ingresar un valor',
                counter: value => value !== null && value.length <= 7 || 'MH Broadcast ID debe tener máximo 7 caracteres'
            }
        };
    }

    get formIsValid(){
        if(this.enabledGreenMile){
            if(
                this.greenmileNumber == null || this.greenmileNumber === '' 
                || this.greenmileNumber.length > 45
            ){
                return false
            }
        }
        if(this.enabledMHBroadcast){
            if(
                this.mhBroadcastNumber == null || this.mhBroadcastNumber === '' 
                || this.mhBroadcastNumber.length > 7
            ){
                return false
            }
        }
        return true
    }

    validateGreenMile(){
        
    }


    updateGreenmileFields(greenmileNumber){
        /* Cuando carga el detalle del vehiculo */
        this.enabledGreenMile = true;
        this.greenmileNumber = greenmileNumber;
        this.updateBroadcastsFields();
    }

    updateMhBroadcastFields(mhBroadcastNumber){
        /* Cuando carga el detalle del vehiculo */
        this.enabledMHBroadcast = true;
        this.mhBroadcastNumber = mhBroadcastNumber;
        this.updateBroadcastsFields();
    }

    updateSendImFields(send_im){
        /* Cuando carga el detalle del vehiculo */
        this.send_im = send_im;
        this.updateBroadcastsFields();
    }

    updateSiporalFields(siporal_broadcast){
        /* Cuando carga el detalle del vehiculo */
        this.siporal_broadcast = siporal_broadcast;
        this.updateBroadcastsFields();
    }

    updateGreenMileValue(){
        this.greenmileNumber = '';
        setTimeout(() => {
            this.greenmileNumber = null;
        }, 0);
    }

    updateGreenmileNumber(value){
        this.greenmileNumber = value;
    }
    updateMHbroadcastNumber(value){
        this.mhBroadcastNumber = value;
    }

    updateMhBroadcastValue(){
        this.mhBroadcastNumber = '';
        setTimeout(() => {
            this.mhBroadcastNumber = null;
        }, 0);
    }

   
    @Emit()
    updateBroadcastsFields(){
        return {
            send_im: this.send_im,
            greenmile_id: this.greenmileNumber,
            mh_broadcast_id: this.mhBroadcastNumber,
            siporal_broadcast: this.siporal_broadcast
        }
    }

    @Emit()
    closeModal() {
       
    }

    applyChanges(){
        this.updateBroadcastsFields();
        this.resetPreselectedCompanies();
        this.closeModal();
    }

    mounted() {
        this.$nextTick(() => {
            
        });
    }
}
